export const roundTo = (value: number, step: number, origin = 0): number =>
    origin + Math.round((value - origin) / step) * step;

export const floorTo = (value: number, step: number, origin = 0): number =>
    origin + Math.floor((value - origin) / step) * step;

export const ceilTo = (value: number, step: number, origin = 0): number =>
    origin + Math.ceil((value - origin) / step) * step;
